import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import TeletelRequiredAttributesIndex from './Index.vue';

/**
 * Required conversation attributes, Teletel's own path.
 *
 * The Chatwoot feature of the same name is premium and stays paywalled and
 * untouched; this is a separate route, component and API. The controller has
 * shipped since the flows batch - this route is what finally makes it reachable
 * without a console.
 *
 * Administrators only. The server enforces the same rule, so hiding the route
 * is a convenience, never the control.
 */
export default {
  routes: [
    {
      path: frontendURL(
        'accounts/:accountId/settings/teletel-required-attributes'
      ),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'teletel_required_attributes',
            params: to.params,
          }),
        },
        {
          path: 'list',
          name: 'teletel_required_attributes',
          meta: {
            permissions: ['administrator'],
          },
          component: TeletelRequiredAttributesIndex,
        },
      ],
    },
  ],
};
